import {
  EventEmitter
} from "events";
import TCVelikClient from '@/TCVelikClient/TCVelikClient.js'

class OpenaIClient extends EventEmitter {
  promptAI(token, Identifier, CanUseCache) {
    if (CanUseCache)
      CanUseCache = false;

    return TCVelikClient.PostRelative("/api/openAI/Prompt", {
      Prompt: token,
      Identifier: Identifier,
      CanUseCache: CanUseCache
    });
  }

  promptRaw(token, Identifier, CanUserCache) {
    if (!CanUserCache)
      CanUserCache = false; // Be exlpicit with the service.

    return TCVelikClient.PostRelative("/api/openAI/PromptRaw", {
      Prompt: token,
      Identifier: Identifier,
      CanUseCache: CanUserCache
    });
  }

  chatRaw(chat) {
    return TCVelikClient.PostRelative("/api/openAI/ChatRaw", chat);
  }

  SaveFeedback(chat) {
    return TCVelikClient.PostRelative("/api/openAI/SaveFeedback", chat);
  }

  chatRawWithFunctions(chat, functionsArr) {
    if (!chat) {
      chat = {
        Messages: [{

        }],
        Functions: [],
      }
    }

    var payLoad = chat;
    if (functionsArr) {
      payLoad.Functions = functionsArr;
    }

    return TCVelikClient.PostRelative("/api/openAI/ChatWithFunctions", payLoad);
  }

  resetAICacheForDocumentAssessment(id) {
    var payload = {
      Id: id
    }
    TCVelikClient.PostRelative("/api/openAI/ResetCacheForDocumentAssessments", payload);
  }
}

export default new OpenaIClient();
